import * as routes from 'api/routes';

export type Result = Array<{ _id: string; name: string; amount: number }>;

export const ROUTE = routes.USER_PORTFOLIO_GET;
